<template>
  <div>
    <v-card class="mx-0">
      <v-card-title>
        <h3 class="primary_dark--text text-center">Simula tu crédito</h3>
      </v-card-title>
      <v-card-text>
        <v-layout px-3 row wrap>
          <v-flex mx-3>
            <h2 class="primary_dark--text break-word mb-4">Solo crédito auto nuevo</h2>
          </v-flex>
          <v-flex mx-3 xs12>
            <h3 class="mb-3">Precio del vehículo</h3>
            <v-text-field
              :rules="rules"
              type="number"
              prefix="$"
              v-model="credit"
              color="primary"
              outlined
            ></v-text-field>
          </v-flex>
          <v-flex mx-3 xs12>
            <h3 class="mb-3">Enganche</h3>
            <v-text-field
              v-model="hitch"
              :rules="required"
              type="number"
              outlined
              value="20"
              prefix="$"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout px-3 mb-2 row wrap>
          <v-flex mx-3 xs12>
            <h2 class="primary_dark--text">Pago mensual aproximado:</h2>
          </v-flex>
        </v-layout>
        <v-container v-if="valid.value" grid-list-xl>
          <v-layout row wrap justify-center>
            <v-flex v-for="item in PPMT" :key="item.total" xs12 sm12 md6>
              <v-card>
                <v-card-title class="white--text justify-center primary_dark">
                  {{item.months}}
                </v-card-title>
                <v-card-text class="text-center mt-3">
                  <h2>{{item.total | currency}}</h2>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-layout v-else row wrap>
          <v-flex xs12 class="text-center">
            <h3>{{valid.msg}}</h3>
          </v-flex>
        </v-layout>
        <v-layout px-3 justify-center row wrap>
          <v-flex mx-3 mt-4 xs12>
            <v-btn color="primary" large class="boldFont" @click="$store.dispatch('home/setTypeCredit','Simulador');$store.dispatch('home/setModalCredit',true)">Solicitar mi crédito</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      credit: 5000,
      hitch: 1000,
      required: [
        v => v/(this.credit/100) >= 20 || "Debes dar un enganche minimo del 20%",
        v => v/(this.credit/100) <= 100 || "No puedes dar un enganche mayor al 100%"  
      ],
      rules: [
        v => v >= 5000 || "El precio minimo es de $5000.00",
        v => v <= 1000000 || "El precio máximo es de $1,000,000.00"
      ]
    };
  },
  methods: {
    IPMT(pv, pmt, rate, per) {
      var tmp = Math.pow(1 + rate, per);
      return 0 - (pv * tmp * rate + pmt * (tmp - 1));
    },
    PMT(rate, nperiod, pv, fv, type) {
      if (!fv) fv = 0;
      if (!type) type = 0;

      if (rate == 0) return -(pv + fv) / nperiod;

      var pvif = Math.pow(1 + rate, nperiod);
      var pmt = (rate / (pvif - 1)) * -(pv * pvif + fv);

      if (type == 1) {
        pmt /= 1 + rate;
      }

      return pmt;
    }
  },
  computed: {
    ...mapState({
      creditTypes: state => state.simulatorCar.creditTypes,
      monthlyPayment: state => state.simulatorCar.monthlyPayment
    }),
    financing() {
      var financing = this.credit - this.hitch;
      financing += financing * 0.05645;
      return financing;
    },
    PPMT() {
      var per = 1;
      var rate = 0.0144;
      var pv = this.financing;
      var fv = 0;
      var type = 0;
      let monthlies = [];

      for(let nper = 12; nper <= 60; nper += 12){
        var pmt = this.PMT(rate, nper, pv, fv, type);
        var ipmt = this.IPMT(pv, pmt, rate, per - 1);
        var total = ipmt - pmt;
        total = total - ipmt;
        monthlies.push({'total': total, 'months':'A '+ nper +' meses'});
      }
      return monthlies;
    },
    valid(){
      if(this.credit < 5000 || this.credit > 1000000){
        return {'value':false,'msg':'El precio del automovil debe estar entre $5000.00 y $1,000,000'};
      }else if(this.hitch/(this.credit/100) < 20 || this.hitch/(this.credit/100) >= 100){
        return {'value':false,'msg':'El enganche debe ser mayor al 20% y menor que el total'};
      }
      return {'value':true,'msg':''};
    }
  }
};
</script>
<style scoped>
.boldFont {
  font-weight: bolder !important;
}
</style>